import { createFileRoute } from "@tanstack/react-router";
import { cityServiceHead } from "../lib/route-head";
import { CityServicePage } from "../components/city-service-page";
import { getCityService } from "../data/city-services";

export const Route = createFileRoute("/paver-restoration-sealing-latham-ny")({
  loader: async () => {
    const c = (await import("../data/city-services")).getCityService("paver-restoration-sealing-latham-ny")!;
    return { meta: c.meta, heroImage: c.heroImage, service: c.service, city: c.city, faqs: c.faqs };
  },
  head: ({ loaderData }) => cityServiceHead("paver-restoration-sealing-latham-ny", "paver-cleaning-sealing", loaderData),
  component: RouteComponent,
});

function RouteComponent() {
  return <CityServicePage content={getCityService("paver-restoration-sealing-latham-ny")!} />;
}
